<template>
    <el-main>
        <div style="margin-bottom: 1rem;">
            <el-button type="primary" icon="el-icon-plus" size="small" style="margin-right: 40px;" @click="addItemDeal">新增</el-button>
            <el-select v-model="sstj.lbbh" size="small" placeholder="请选择任务类型" style="margin-right: 20px;width: 15rem;" @change="qgQuery">
                <el-option
                    v-for="item in rwlxs"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                >
                </el-option>
            </el-select>
            <el-select v-model="sstj.xcrId" size="small" placeholder="请选择执行人" style="margin-right: 20px;width: 15rem;" @change="qgQuery">
                <el-option
                    v-for="item in zxrs"
                    :key="item.userid"
                    :label="item.name"
                    :value="item.userid"
                >
                </el-option>
            </el-select><el-select v-model="sstj.zt" size="small" placeholder="请选择状态" style="margin-right: 20px;width: 15rem;" @change="qgQuery">
                <el-option
                    v-for="item in zts"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                >
                </el-option>
            </el-select>
            <el-date-picker
                size="small"
                style="margin-right: 20px;width: 15rem;"
                v-model="sstj.date"
                type="date"
                placeholder="请选择日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="qgQuery"
            >
            </el-date-picker>
            <el-button type="primary" size="small" style="background-color: #a8a8a8;border: solid 0rem #f4f4f4;" @click="resetRwDataDeal">重置</el-button>
            <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding" @click="qgQuery">搜索</el-button>
        </div>
        <div class="commonDiv">
            <el-table
                :data="lxTableData"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                border
                ref="ryTableRef"
                size="mini"
                @selection-change="tableSelectionChange"
                @sort-change="lxSortChange"
                :row-style="tableRowClassName"
                style="width: 100%;"
                height="calc(100% - 60px)"
                :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}"
            >
                <el-table-column prop="rwxxmc" label="巡查名称" align="center">
                    <template slot-scope="scope">
                        <span style="color: #46adf5;cursor: pointer;" @click="seeXc(scope.row)">{{ scope.row.rwxxmc }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lbmc" label="任务类型" align="center"/>
                <el-table-column prop="xcxlmc" label="巡查线路" align="center"/>
                <el-table-column prop="xcrmc" label="执行人" align="center"/>
                <el-table-column prop="xcdt" label="计划执行日期" align="center"/>
                <el-table-column prop="zt" label="状态" align="center">
                    <template slot-scope="scope">
                        <div>
                            <div v-if="scope.row.zt == 0">
                                未巡查
                            </div>
                            <div v-if="scope.row.zt == 1">
                                巡查中
                            </div>
                            <div v-if="scope.row.zt == 2">
                                已巡查
                            </div>
                            <div v-if="scope.row.zt == 3">
                                暂停巡查
                            </div>
                            <div v-if="scope.row.zt == 4">
                                关闭
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150" v-if="authorityMap.isDel">
                    <template slot-scope="scope">
                        <el-tooltip content="删除" effect="light" v-if="authorityMap.isDel">
                            <el-popconfirm
                                title="确定删除吗？"
                                @confirm="lxItemDeleteDeal(scope.row)"
                            >
                            <img
                                src="~@/assets/images/operates/delete.png"
                                alt=""
                                slot="reference"
                                style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                            />
                            </el-popconfirm>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="commonPage2">
                <el-pagination
                    @size-change="lxHandleSizeChange"
                    @current-change="gzHandleCurrentChange"
                    :page-sizes="[10, 20, 30]"
                    :page-size="params.size"
                    :current-page="params.current"
                    layout="total, prev, pager, next,sizes, jumper"
                    background
                    :total="params.total"
                >
                </el-pagination>
            </div>
        </div>
        <data-dialog
            :dialog-title="rwDialog.title" 
            :is-visible="rwDialog.ryFormVisible" 
            :is-read="isRead"
            @dgVerifyDeal="dgVerifyDeal('rwDialog','dialog')" 
            ref="rwDialog" 
            @dgConfirmDeal="dgRyConfirmDeal"
            @dgCancelDeal="dgCancelDeal"
            :dgStyle="dgSmallStyle"
            :is-own-style="true"
        >
            <div slot="dialogFrom">
                <el-form
                    ref="dialog"
                    :model="rwDialog.data"
                    :rules="lxRules"
                    label-position="top"
                    :disabled="isRead"
                >
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="巡查名称" prop="mc" style="width: 80%;">
                                <el-input v-model="rwDialog.data.mc" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="任务类型" prop="lbbh" style="width: 80%;">
                                <el-select v-model="rwDialog.data.lbbh" placeholder="请选择" style="width: 100%;">
                                    <el-option
                                        v-for="item in rwlxs"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="巡查线路" prop="xclxid" style="width: 80%;">
                                <el-select v-model="rwDialog.data.xclxid" placeholder="请选择" style="width: 100%;">
                                    <el-option
                                        v-for="item in xclxs"
                                        :key="item.id"
                                        :label="item.mc"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="执行人" prop="userid" style="width: 80%;">
                                <el-select v-model="rwDialog.data.userid" placeholder="请选择" style="width: 100%;">
                                    <el-option
                                        v-for="item in zxrs"
                                        :key="item.userid"
                                        :label="item.name"
                                        :value="item.userid"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="计划执行日期" prop="kssj" style="width: 80%;">
                                <el-date-picker
                                    v-model="rwDialog.data.kssj"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="width: 100%;"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="计划结束日期" prop="jssj" style="width: 80%;">
                                <el-date-picker
                                    v-model="rwDialog.data.jssj"
                                    type="date"
                                    placeholder="选择日期"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    style="width: 100%;"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="备注" prop="bz" style="width: 100%;">
                                <el-input v-model="rwDialog.data.bz" type="textarea" :rows="3"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="是否为周期任务" prop="sfzqrw" style="width: 100%;">
                                <template #label>
                                    是否为周期任务
                                    <el-switch
                                        v-model="rwDialog.data.sfzqrw"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                    >
                                    </el-switch>
                                </template>
                                <div>
                                    <el-radio :disabled="!rwDialog.data.sfzqrw" v-model="rwDialog.data.zqsj" label="0">每天</el-radio>
                                    <el-radio :disabled="!rwDialog.data.sfzqrw" v-model="rwDialog.data.zqsj" label="1">周天</el-radio>
                                    <el-radio :disabled="!rwDialog.data.sfzqrw" v-model="rwDialog.data.zqsj" label="2">周一</el-radio>
                                    <el-radio :disabled="!rwDialog.data.sfzqrw" v-model="rwDialog.data.zqsj" label="3">周二</el-radio>
                                    <el-radio :disabled="!rwDialog.data.sfzqrw" v-model="rwDialog.data.zqsj" label="4">周三</el-radio>
                                    <el-radio :disabled="!rwDialog.data.sfzqrw" v-model="rwDialog.data.zqsj" label="5">周四</el-radio>
                                    <el-radio :disabled="!rwDialog.data.sfzqrw" v-model="rwDialog.data.zqsj" label="6">周五</el-radio>
                                    <el-radio :disabled="!rwDialog.data.sfzqrw" v-model="rwDialog.data.zqsj" label="7">周六</el-radio>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </data-dialog>
        <data-dialog
            :dialog-title="ckDialog.title" 
            :is-visible="ckDialog.ryFormVisible" 
            :is-read="ckisRead"
            @dgVerifyDeal="dgVerifyDeal('ckDialog','dialog')" 
            ref="ckDialog" 
            @dgCancelDeal="seeCancelDeal"
            :dgStyle="dgSmallStyle"
            :is-own-style="true"
        >
            <div slot="dialogFrom">
                <el-form
                    ref="dialog"
                    :model="ckDialog.data"
                    :rules="lxRules"
                    label-position="top"
                    :disabled="ckisRead"
                >
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="巡查名称" prop="rwxxmc" style="width: 80%;">
                                <el-input v-model="ckDialog.data.rwxxmc" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="任务类型" prop="lbmc" style="width: 80%;">
                                <el-input v-model="ckDialog.data.lbmc" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="巡查线路" prop="xcxlmc" style="width: 80%;">
                                <el-input v-model="ckDialog.data.xcxlmc" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="执行人" prop="xcrmc" style="width: 80%;">
                                <el-input v-model="ckDialog.data.xcrmc" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="计划执行日期" prop="xcdt" style="width: 80%;">
                                <el-date-picker
                                    v-model="ckDialog.data.xcdt"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    style="width: 100%;"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="执行状态" prop="zt" style="width: 80%;">
                                <el-input v-model="ckDialog.data.zt" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="巡查轨迹路径图" prop="xclj" style="width: 100%;">
                                <div>
                                    <div class="map" id="olMap"></div>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </data-dialog>
    </el-main>
</template>
  
<script>
import DataDialog from "../../components/tableGather/dataDialog";
import QueryGather from "../../components/buttonGather/queryGather";

import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import { Tile as TileLayer, Vector as VectorLayer, Image } from "ol/layer";
import VectorSource from "ol/source/Vector";
import { XYZ, WMTS, ImageWMS } from "ol/source";
import { defaults as defaultControls } from "ol/control";
import Point from "ol/geom/Point";
import Feature from "ol/Feature";
import Overlay from "ol/Overlay";
import { Icon,Style,Stroke,Fill,Circle as CircleStyle,Circle,Text } from "ol/style";

import ImageLayer from 'ol/layer/Image';
import { GeoJSON, WKT } from "ol/format";
import LinearRing from 'ol/geom/LinearRing.js';
import { Polygon } from "ol/geom/Polygon";
import LineString from 'ol/geom/LineString';



let tdtLayer = null;
let yxdtLayer = null;
let hlLayer =null;
let dtImage = new VectorLayer({
    source: new VectorSource(),
    visible: true,
});
let cz_img = new VectorLayer({
    source:new VectorSource(),
    visible: true,
    zIndex:110,
});



export default {
    components: {DataDialog, QueryGather},
    data() {
        let validateMcLen = (rule, value, callback) => {
            if (value == null || value.length == 0) {
                callback();
            } else {
                if (value.length > 30) {
                    return callback(new Error("长度不能超过30个字符"));
                } else {
                    return callback();
                }
            }
        };
        let bzbz = (rule, value, callback) => {
            if (value == null || value.length == 0) {
                callback();
            } else {
                if (value.length > 100) {
                    return callback(new Error("长度不能超过100个字符"));
                } else {
                    return callback();
                }
            }
        };
        return {
            dgSmallStyle: {
                height: '60%',
                marginTop: '0px',
                width: '35vw',
            },
            authorityMap: {
                isAdd: false,//新增权限
                isUpdate: false,//修改权限
                isDel: false,//删除权限
                isView: false,//查看权限
            },
            isRead: false,
            stRemHeight: 0,
            curInputTip: '请输入路线名称',

            lxTableData: [],
            lxRules: {
                mc: [
                    {required: true, message: "请输入路线名称", trigger: "blur"},
                    {validator: validateMcLen, trigger: 'blur'},
                ],
                lbbh: [
                    {required: true, message: "请选择任务类型", trigger: "blur"},
                ],
                xclxid: [
                    {required: true, message: "请选择巡查路线", trigger: "blur"},
                ],
                userid: [
                    {required: true, message: "请选择执行人", trigger: "blur"},
                ],
                kssj: [
                    {required: true, message: "请选择计划执行日期", trigger: "blur"},
                ],
                jssj: [
                    {required: true, message: "请选择计划结束日期", trigger: "blur"},
                ],
                bz: [
                    {validator: bzbz, trigger: 'blur'},
                ],
            },
            params: {
                total: 1,
                size: 10,
                current: 1,
            },
            sstj:{
                zt:'',
                xcrId:'',
                lbbh:'',
                date:'',
            },
            loading: false,
            lxMultiple: true,
            lxMultipleSelection: [],
            curInputValue: '',
            rwDialog: {
                title: "",
                ryFormVisible: false,
                data: {
                    mc: '',
                    lbbh: '',
                    xclxid: '',
                    userid: '',
                    kssj:'',
                    jssj:'',
                    bz:'',
                    sfzqrw:true,
                    zqsj:'',
                },
            },
            xcdmc:'',
            rwlxs:[],
            xclxs:[],
            zxrs:[],
            zts:[
                {id: 0, label: "未巡查"},
                {id: 1, label: "巡查中"},
                {id: 2, label: "已巡查"},
                {id: 3, label: "暂停巡查"},
                {id: 4, label: "关闭"},
            ],
            isIndeterminate: true,
            checkAll: false,
            dialogData: {
                mc: '',
                lbbh: '',
                xclxid: '',
                userid: '',
                kssj:'',
                jssj:'',
                bz:'',
                sfzqrw:true,
                zqsj:'',
            },

            ckDialog: {
                title: "",
                ryFormVisible: false,
                data: {
                    mc: '',
                    lbbh: '',
                    xclxid: '',
                    userid: '',
                    kssj:'',
                    jssj:'',
                    bz:'',
                    sfzqrw:true,
                    zqsj:'',
                },
            },
            ckisRead:true,

            skdtxx:[],
            fdlevel:null,
            map:null,
            maplx:null,
            zoomNum:10,
            center:[83.166136, 42.148747],
            mapData:[],
        }
    },
    created() {
        let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
        this.stRemHeight = windowHeight / 100;
    },
    mounted() {
        this.initStaffData();
        this.getXzData();
    },
    watch: {
        "$store.state.head.skCd"() {
            this.resetRwDataDeal();
        }
    },
    methods: {
        resetRwDataDeal() {
            this.sstj = {
                zt:'',
                xcrId:'',
                lbbh:'',
                date:'',
            };
            this.clearTableStatus();
            this.getXcxlData();
        },
        clearTableStatus() {
            this.$refs.ryTableRef.clearSort();
        },

        initStaffData() {
            this.pageAuthorityDeal();
            this.getXcxlData();
        },
        pageAuthorityDeal() {
            const thirdAuthority = JSON.parse(localStorage.getItem("thirdAuthority"))
            const qx = thirdAuthority[this.$route.name];
            if (qx === 'all' || qx === null) {
                this.authorityMap.isAdd = true;
                this.authorityMap.isDel = true;
                this.authorityMap.isUpdate = true;
                this.authorityMap.isView = true;
            } else {
                this.authorityMap.isAdd = qx.indexOf('新增') !== -1;
                this.authorityMap.isDel = qx.indexOf('删除') !== -1;
                this.authorityMap.isUpdate = qx.indexOf('修改') !== -1;
                this.authorityMap.isView = qx.indexOf('查询') !== -1;
            }
        },
        dgCancelDeal() {
            if (this.rwDialog.ryFormVisible) {
                this.rwDialog.ryFormVisible = false;
                this.$refs['dialog'].clearValidate();
            }
        },
        dgRyConfirmDeal() {
            this.isRead = false;
            this.addRw();
        },
        dgVerifyDeal(dgRef, frRef) {
            this.$refs[frRef].validate((valid) => {
                if (valid) {
                    this.$refs[dgRef].isShowPop(true);
                } else {
                    this.$refs[dgRef].isShowPop(false);
                }
            });
        },
        addRw() {
            this.request.post('/rm-xrw/v1', this.rwDialog.data).then(res => {
                if (res.ok) {
                    this.rwDialog.ryFormVisible = false;
                    this.rwDialog.data = {};
                    this.isAddData = false;
                    this.params = {
                        total: 0,
                        size: 10,
                        current: 1,
                    };
                    this.$message.success('创建任务成功！');
                    this.getXcxlData();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        
        initGetRwData() {
            this.params = {
                total: 0,
                size: 10,
                current: 1,
            };
            this.getXcxlData();
        },
        qgQuery(params) {
            this.curInputValue = params.curInputValue;
            this.params.current = 1;
            this.clearTableStatus();
            this.getXcxlData();
        },
        getXcxlData() {
            this.loading = true;
            let params = {
                ...this.params,
                ...this.sstj
            }
            this.request.get('/rm-xxcrw/v1/page', {params: params}).then(res => {
                if (res.ok) {
                    this.lxTableData = [];
                    this.lxTableData = res.data['records'];
                    this.params.total = res.data.total;
                } else {
                    this.$message.error(res.error.message);
                }
                this.loading = false;
            });
        },






        addItemDeal() {
            this.rwDialog.title = '创建任务';
            this.rwDialog.ryFormVisible = true;
            this.rwDialog.data = {...this.dialogData};
            this.isAddData = true;
            this.isRead = false;
        },
        getXzData(){
            this.request.get('/rm-sdictionary/v1/query/14').then(res => {
                if (res.ok) {
                    this.rwlxs = res.data;
                } else {
                    this.$message.error(res.error.message);
                }
            });
            this.request.get('/rm-xxclx/queryXclxChoose').then(res => {
                if (res.ok) {
                    this.xclxs = res.data;
                } else {
                    this.$message.error(res.error.message);
                }
            });
            this.request.get('/rm-suserrsvr/queryUserChoose').then(res => {
                if (res.ok) {
                    this.zxrs = res.data;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        seeXc(row){
            this.request.get('/rm-xxcrw/xcrwXq/'+ row.id).then(res => {
                if (res.ok) {
                    this.ckDialog.data = res.data;
                    if (this.ckDialog.data.zt == 0) {
                        this.ckDialog.data.zt = '未巡查';
                    } else if (this.ckDialog.data.zt == 1) {
                        this.ckDialog.data.zt = '巡查中';
                    } else if (this.ckDialog.data.zt == 2) {
                        this.ckDialog.data.zt = '已巡查';
                    } else if (this.ckDialog.data.zt == 3) {
                        this.ckDialog.data.zt = '暂停巡查';
                    } else{
                        this.ckDialog.data.zt = '关闭';
                    }
                    this.ckDialog.title = '查看巡查任务信息';
                    this.ckDialog.ryFormVisible = true;
                    this.isAddData = false;
                    this.hqskdtxx();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        hqskdtxx(){
            this.request.get('/rm-bspecial/v1/list').then((res) => {
                if(res.ok){
                    this.skdtxx = res.data;
                    let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
                    for (let i = 0; i < this.skdtxx.length; i++) {
                        if (skCd == parseFloat(this.skdtxx[i].bh)) {
                            this.zoomNum = parseFloat(this.skdtxx[i].level);
                            this.fdlevel = parseFloat(this.skdtxx[i].fdlevel);
                            this.center[0] = parseFloat(this.skdtxx[i].jd);
                            this.center[1] = parseFloat(this.skdtxx[i].wd);
                            break;
                        } else {
                            this.zoomNum = 4;
                            this.center = [103.95, 34.10];
                        }
                    }
                    this.initMap();
                }else{
                    this.$message.error(res.error.message)
                }
            });
        },
        //初始化地图
        initMap() {
            let skCd = localStorage.getItem("skCd") ? localStorage.getItem("skCd") : null;
            for (let i = 0; i < this.skdtxx.length; i++) {
                if (skCd == parseFloat(this.skdtxx[i].bh)) {
                    this.maplx = this.skdtxx[i].map;
                    this.zoomNum = parseFloat(this.skdtxx[i].level);
                    this.fdlevel = parseFloat(this.skdtxx[i].fdlevel);
                    this.center[0] = parseFloat(this.skdtxx[i].jd);
                    this.center[1] = parseFloat(this.skdtxx[i].wd);
                    break;
                } else {
                    this.zoomNum = 4;
                    this.center = [103.95, 34.10];
                }
            }

            tdtLayer = new TileLayer({
                source: new XYZ({  //矢量底图
                    url: 'https://t{0-7}.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=vec_w&tk=8156b60f5ff7ee9619e3c84a1a7fe491'
                }),
                visible: true,
            });
            yxdtLayer = new TileLayer({
                source: new XYZ({  //影像底图
                    url: 'https://t{0-7}.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=img_w&tk=8156b60f5ff7ee9619e3c84a1a7fe491'
                }),
                visible: false,
            });

            
            if (skCd) {
                if(skCd == '65292330001' || this.maplx == "JD"){
                    tdtLayer.setVisible(true);
                    yxdtLayer.setVisible(false);
                } else if(this.maplx == "YX") {
                    tdtLayer.setVisible(false);
                    yxdtLayer.setVisible(true);
                }
            }

            // 加载地图
            const map = new Map({
                target: "olMap",
                layers:[tdtLayer,yxdtLayer],
                view: new View({
                    //中心点经纬度
                    center: this.center,
                    //图层缩放大小
                    zoom: this.zoomNum,
                    projection: "EPSG:4326",
                    minZoom: 4,
			        // maxZoom: 18,
                }),
                controls: defaultControls({
                    zoom: true,
                    attribution: false,
                    rotate: false,
                }),
            });
            this.map = map;


            // let aasda = [
            //     {lgtd: "83.071616", lttd: "41.963194"},
            //     {lgtd: "84.071616", lttd: "40.963194"}
            // ]

            if (!this.ckDialog.data.xclj) {
                return
            }
            //添加点
            let pointTc = new VectorLayer({
                source: new VectorSource(),
                visible: true,  
            });
            this.map.addLayer(pointTc);
            this.ckDialog.data.xclj.forEach((n)=>{
                var point = new Feature({
                    geometry: new Point([n.lgtd, n.lttd])
                });
                point.setStyle(new Style({
                        //形状
                        image: new Circle({
                        radius: 4,
                        fill: new Fill({
                            color: '#cc0000'
                        }),
                        zIndex:100,
                    })
                }));
                pointTc.getSource().addFeature(point);
            })

            //添加线
            let lineTc = new VectorLayer({
                source: new VectorSource(),
                visible: true,  
            });
            this.map.addLayer(lineTc);
            for (let i = 0; i < this.ckDialog.data.xclj.length - 1; i++) {
                let a = [this.ckDialog.data.xclj[i].lgtd,this.ckDialog.data.xclj[i].lttd];
                let b = [this.ckDialog.data.xclj[i+1].lgtd,this.ckDialog.data.xclj[i+1].lttd];
                //创建一个线
                var Line = new Feature({
                    geometry: new LineString([a, b])
                });
                //设置线的样式
                Line.setStyle(new Style({
                    //填充色
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.2)'
                    }),
                    //边线颜色
                    stroke: new Stroke({
                        color: '#ea8d60',
                        width: 2
                    }),
                    //形状
                    image: new Circle({
                        radius: 20,
                        fill: new Fill({
                            color: '#4a8fff'
                        })
                    })
                }));
                lineTc.getSource().addFeature(Line);
            }
        },
        seeCancelDeal() {
            if (this.ckDialog.ryFormVisible) {
                // 销毁地图实例并移除DOM元素
                this.map.setTarget(null);
                this.map.dispose();
                // const mapDiv = document.getElementById('olMap');
                // document.body.removeChild(mapDiv);

                this.ckDialog.ryFormVisible = false;
                this.$refs['dialog'].clearValidate();
            }
        },
        lxItemDeleteDeal(row) {
            this.request.delete('/rm-xxcrw/v1/' + row.id).then(res => {
                if (res.ok) {
                    this.$message.success("巡查路线删除成功");
                    this.initGetRwData();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },


        lxSortChange(column) {
            let params = {
                total: 0,
                size: 10,
                current: 1,
                sortCol: column.prop.toUpperCase(),
                order: column.order === "descending" ? 1 : 0,
            };
            this.params = {};
            this.params = params;
            this.getXcxlData();
        },
        tableSelectionChange(val) {
            this.lxMultiple = !val.length;
            this.lxMultipleSelection = val;
        },
        tableRowClassName({row, rowIndex}) {
            return {
                backgroundColor: '#ffffff',
                fontSize: '1.4rem',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontFamily: 'PingFang SC',
                color: '#616f7b',
                height: '5.83vh',
            };
        },
        lxHandleSizeChange(val) {
            this.params.size = val;
            this.params.current = 1;
            this.getXcxlData();
        },
        //切换页码
        gzHandleCurrentChange(val) {
            this.params.current = val;
            this.getXcxlData();
        },
        
    },
}
</script>
<style scoped>
.commonDiv {
    position: relative;
    background-color: #FFFFFF;
    height: calc(100vh - 200px);
}
::v-deep .el-pagination{
    white-space: nowrap;
    color: #303133;
    font-weight: 700;
    transform: translate(0, -50%);
    position: relative;
    top: 50%;
    right: 20px;
}
.commonPage2 {
    position: absolute;
    right: 1.5rem;
    height: 60px;
}

.input-class /deep/ .el-input__inner {
    border-radius: 30px;
}

.map {
    width: 100%;
    height: 300px;
}
::v-deep .ol-zoom{
    display:none;
}
</style>
  